<template>
  <span role="timer">
    <span class="sr-only">{{ accessibilityTitle }}</span>
    <client-only>
      <span>{{ time }}</span>
      <template #fallback>
        <span class="animate-pulse">{{ time }}</span>
      </template>
    </client-only>
  </span>
</template>

<script lang="ts" setup>
import type { CountdownConfig } from '#types/components/cms/dynamic-fields'

const { endTime, accessibilityTitle } = defineProps<CountdownConfig>()

const { $t } = useNuxtApp()
const { units } = useAppConfig().components.cms.countdown

const epochEndTime = new Date(endTime).getTime()

const enabledOptions = units.filter((option) => $t.countdownFormat.includes(option.code))

const time = ref(enabledOptions.reduce((acc, option) => acc.replace(option.code, '--'), $t.countdownFormat as string))

const { pause } = useIntervalFn(update, 1000)

onMounted(() => update())

function update() {
  let remaining = Math.max(0, Math.floor((epochEndTime - Date.now()) / 1000))

  if (!remaining) pause()

  const smallestUnit = enabledOptions[enabledOptions.length - 1]
  if (smallestUnit)
    remaining = Math.ceil(remaining / smallestUnit.seconds) * smallestUnit.seconds

  time.value = enabledOptions.reduce((acc, option) => {
    acc = acc.replace(option.code, String(Math.floor(remaining / option.seconds)).padStart(2, '0'))
    remaining %= option.seconds
    return acc
  }, $t.countdownFormat as string)
}
</script>
